<template>
  <van-address-edit
      :area-list="areaLists"
      :address-info="infoList"
      show-postal
      show-set-default
      detail-rows="2"
      @save="onSave"
  />
</template>

<script>
import {defineComponent, ref, computed, onMounted} from 'vue';
import { areaList } from '@vant/area-data';
import {addConsignee, getConsigneeById, editConsignee} from '@/api/consignees';
import store from '@/store';
import {isNotEmpty} from '@/utils/util';
import {useRouter, useRoute} from "vue-router";
import {Toast} from 'vant';

export default defineComponent({
  name: 'ReceivingAddressEdit',
  setup() {
      const route = useRoute();
      const router = useRouter();
      const uid = computed(() => {
          return store.state.reader.user.uid;
      });
      const areaLists = ref({}); // 省市区数据
      const infoList = ref({}); // 列表信息
      const id = ref('');
      const onSave = (content) =>{
          const address = {'province':content.province,'city':content.city,'area':content.county,'detail':content.addressDetail, 'areaCode': content.areaCode};
          let param = {
              'consignee': content.name,
              'consigneePhone': content.tel,
              'consigneeAddress': JSON.stringify(address),
              'consigneePostcode': content.postalCode,
              'isPreferred': content.isDefault ? 1: 0,
              'uid': uid.value
          };
          if(id.value){
              // 编辑
              param.id = id.value;
              editConsignee(param)
                  .then(data => {
                      if(isNotEmpty(data)){
                          router.go(-1);
                          Toast({message: '保存成功'});
                      }
                  })
                  .catch((error) => {
                      console.error(error);
                  });
          }else {
              // 新增
              addConsignee(param)
                  .then(data => {
                      if(isNotEmpty(data)){
                          router.go(-1);
                          Toast({message: '新增成功'});
                      }
                  })
                  .catch((error) => {
                      console.error(error);
                  });
          }
      };
      // 根据id获取单个收货地址
      const onConsignee = (id) => {
          getConsigneeById(id)
              .then(data => {
                  if(isNotEmpty(data)){
                      let address = {};
                      if(isNotEmpty(data.consigneeAddress)){
                          address = JSON.parse(data.consigneeAddress);
                      }
                      infoList.value = {
                          name: data.consignee,
                          tel: data.consigneePhone,
                          areaCode: address.areaCode,
                          addressDetail: address.detail,
                          postalCode: data.consigneePostcode,
                          isDefault: !!data.isPreferred,
                      };
                  }
              })
              .catch((error) => {
                  console.error(error);
              });
      };
      onMounted(() => {
          areaLists.value = areaList;
          if(isNotEmpty(route.query) && isNotEmpty(route.query.id)){
              id.value = route.query.id;
              onConsignee(id.value);
          }else {
              id.value = '';
          }
      });
	    return {
		      onSave,
          areaLists,
		      onConsignee,
		      infoList,
		      id
	    };
  },
});
</script>

<style scoped lang="less">
@import "../assets/css/address-edit.less";
</style>
